module.exports = __webpack_public_path__ + "static/img/unionPay.a54e830.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/footer/unionPay.webp
// module id = 4jbs
// module chunks = 3